import { Directive, HostListener, Input } from '@angular/core';
import { HelpService } from '../services/help.service';

@Directive({
  selector: '[appClipboardCopy]',
  standalone: false
})
export class ClipboardCopyDirective {

  constructor(private readonly helpService: HelpService,) { }

  @Input('appClipboardCopy') textToCopy!: string;

  @HostListener('click')
  copyText(): void {
    if (!this.textToCopy) return;

    navigator.clipboard.writeText(this.textToCopy).then(() => {
      this.helpService.showMessageNotification(`Value copied: ${this.textToCopy}`, 'success');
    }).catch(_ => {
      this.helpService.showMessageNotification('Failed to copy text', 'error');
    });
  }
}